__turbopack_context__.v({
  "feature": "features-module-scss-module__ziRJWG__feature",
  "featureIcon": "features-module-scss-module__ziRJWG__featureIcon",
  "featureText": "features-module-scss-module__ziRJWG__featureText",
  "features": "features-module-scss-module__ziRJWG__features",
  "featuresList": "features-module-scss-module__ziRJWG__featuresList",
  "featuresTitle": "features-module-scss-module__ziRJWG__featuresTitle",
  "featuresWrp": "features-module-scss-module__ziRJWG__featuresWrp",
});
